var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106.361,
    height: 110.891,
    viewBox: "0 0 106.361 110.891",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m89.138 63.755 17.223 9.971-10.575 18.433-17.224-9.971A115.758 115.758 0 0 1 61.34 69.496a110.133 110.133 0 0 1 2.417 21.151v20.244H42.606V90.647c.12-7.112.93-14.195 2.417-21.151A115.718 115.718 0 0 1 27.8 82.188l-17.223 9.971L0 73.725l17.225-9.97a116.55 116.55 0 0 1 19.64-8.459 87.883 87.883 0 0 1-19.64-8.158L0 36.863l10.577-18.129L27.8 28.705a84.709 84.709 0 0 1 17.223 12.692 113.461 113.461 0 0 1-2.417-21.456V0h21.151v19.941a113.461 113.461 0 0 1-2.417 21.456 84.729 84.729 0 0 1 17.222-12.692l17.224-9.971 10.575 18.129-17.223 10.275a87.883 87.883 0 0 1-19.64 8.158 116.55 116.55 0 0 1 19.64 8.459z",
    fill: "#FFE400",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.37edee89d87d15923f3c3f7ab8ff5028.svg";
export { ForwardRef as ReactComponent };